import React, { useState } from 'react';
import SheEarnsGridCanvas from './SheEarnsGridCanvas';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBook, faRuler, faListAlt, faTh, faA, fa1, faTable, faList, faSmile } from '@fortawesome/free-solid-svg-icons';
import { useNavigate, useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import './SheEarnsNotesCanvas.css';
import axios from 'axios';
import { useSelector } from 'react-redux';

const canvasComponents = [
  { icon: faTh, component: SheEarnsGridCanvas, name: '2x2 Grid', props: { rows: 2, cols: 2 } },
  { icon: faTh, component: SheEarnsGridCanvas, name: '3x3 Grid', props: { rows: 3, cols: 3 } },
  { icon: faTh, component: SheEarnsGridCanvas, name: '4x4 Grid', props: { rows: 4, cols: 4 } },
  { icon: faTh, component: SheEarnsGridCanvas, name: '5x5 Grid', props: { rows: 5, cols: 5 } },
  { icon: faTh, component: SheEarnsGridCanvas, name: '10x10 Grid', props: { rows: 10, cols: 10 } },
  { icon: faList, component: SheEarnsGridCanvas, name: '2x5 Grid', props: { rows: 2, cols: 5 } }
];

const SheEarnsTouchBookGrid = () => {
  const authState = useSelector(state => state.authReducer);
  const navigate = useNavigate();

  const [overlayContent, setOverlayContent] = useState(null);

  const handleIconClick = (Component, props = {}) => {
    setOverlayContent(() => <Component {...props} onClose={handleCloseOverlay} />);
  };

  const handleCloseOverlay = () => {
    setOverlayContent(null);
  };

  const handleBackToHome = () => {
    navigate(-1)
  };

  return (
    <div className="full-screen-overlay">
      <div className='flex flex-col'>
        <div className='flex justify-center items-center my-4'>
            <p className='text-white bg-pink-600 text-m lg:text-lg rounded-lg px-6 py-2 shadow-lg'>
                SAKSHAM Shakti Digital Grid Book
            </p>
        </div>
        <div className="canvas-grid">
            {canvasComponents.map((item, index) => (
                <div 
                key={index} 
                className="icon text-white" 
                onClick={() => handleIconClick(item.component, item.props)}
                >
                <FontAwesomeIcon className="text-white" icon={item.icon} size="200px" />
                <p className='text-white'>{item.name}</p>
                </div>
            ))}
        </div>
        {overlayContent && (
            <div className="overlay">
            {overlayContent}
            </div>
        )}
        <div>
            <button className="bg-pink-600 text-white" onClick={handleBackToHome}>Close</button>
        </div>
    </div>
   </div>
  );
};

export default SheEarnsTouchBookGrid;

